import React from 'react';

import * as Styled from './LoadingScreen.styles';
import useGlobalStore from '../../utils/store';
import { fadeMotionProps } from 'utils/styles/animations';

export interface LoadingScreenProps {}

const LoadingScreen: React.FC<LoadingScreenProps> = () => {
  const { loadedPercentage } = useGlobalStore();

  return (
    <Styled.Wrapper {...fadeMotionProps}>
      <Styled.ProgressBar>
        <Styled.ProgressBarPercentage
          style={{
            transform: `scaleX(${loadedPercentage})`,
            opacity: loadedPercentage < 1 ? 1 : 0,
          }}
        />
      </Styled.ProgressBar>      
    </Styled.Wrapper>
  );
};

export default LoadingScreen;
